// Las reseñas se incorporan aquí únicamente después de ser revisadas y aprobadas.
export const approvedReviews = [
  {
    id: 'noemi-arriagada-kapping',
    customerName: 'Noemi Arriagada',
    serviceName: 'Reforzamiento de uña natural / Kapping',
    rating: 5,
    comment:
      'No cambiaría nada de mi experiencia. La ubicación es muy conveniente, el servicio fue excelente y mis uñas quedaron hermosas. Además, Poleth hizo que la atención fuera muy agradable: conversamos y nos reímos bastante. Sin duda, es un servicio 100% recomendable.',
  },
];
